import { mutatorAction } from "satcheljs";
import getStore from "../store/store";
import type ViewType from "../store/schema/ViewType";

const updateWin32StyleReadingPaneViewPreviewMutator: (isWin32StyleEnabled: boolean, currentReadingPaneViewType: ViewType) => void = mutatorAction("updateWin32StyleReadingPaneViewPreview", (isWin32StyleEnabled: boolean, currentReadingPaneViewType: ViewType): void => {
    const store = getStore();
    
    if (isWin32StyleEnabled) {
        store.nonWin32StyleReadingPaneViewType ??= currentReadingPaneViewType;
        store.readingPaneViewType = 2;
    }
    else if (store.nonWin32StyleReadingPaneViewType !== null) {
        store.readingPaneViewType = store.nonWin32StyleReadingPaneViewType;
        store.nonWin32StyleReadingPaneViewType = null;
    }
});

export default updateWin32StyleReadingPaneViewPreviewMutator;
